import { PropertyValues } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { GzSingleSelectWebComponent } from '../../gzSingleSelectDropdown';
import { SelectedOption } from '../../gzSingleSelectList/types';

/**
 * @summary Extend the single select as to not fire any events on the first render
 * @tag gz-single-select-loaded
 * Here https://custom-elements-manifest.open-wc.org/analyzer/getting-started/ you can find out how to document the code
 */
@customElement('gz-single-select-loaded')
export class GzSingleSelectLoadedWebComponent extends GzSingleSelectWebComponent {

  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  @state()
  private firstLoaded = true;

  updated(properties: PropertyValues): void {
    if (!this.firstLoaded) {
      if (properties.has('value')) {
        this.setFormValue(this.value);
      }
    }
    const selectedOption = this.filterOptions.find((option => option.value === this.value)) as SelectedOption;
    this.updateDropdownLabelWithSelectedValues(selectedOption);
    this.firstLoaded = false;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'gz-single-select-loaded': GzSingleSelectLoadedWebComponent;
  }
}
